import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4916976b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import {
  computed, withDefaults,
} from 'vue';
import { useRouter } from 'vue-router';
import SwIcon from '@/components/molecules/Icons/SwIcon.vue';
import { ColorType, IconType } from '@/types/ui-components';

interface Props {
  icon?: IconType;
  label?: string;
  color?: ColorType;
  to?: string;
  disabled?: boolean;
}

interface Emits {
  (e: 'click'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwNavbarButton',
  props: {
    icon: { default: 'sw-icon-like' },
    label: { default: '' },
    color: { default: 'primary' },
    to: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { icon: IconType, label: string, color: ColorType, to?: string, disabled: boolean }

const router = useRouter();



/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-navbar-item-button': true,
  [`sw-navbar-item-button--${props.color || 'primary'}`]: true,
  'sw-navbar-item-button--disabled': props.disabled,
}));


/**
 * ボタンクリック時
 */
const onClick = () => {
  emit('click');

  if (props.to) {
    router.push(props.to);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(_unref(classes)),
    onClick: onClick,
    disabled: __props.disabled
  }, [
    (__props.icon)
      ? (_openBlock(), _createBlock(SwIcon, {
          key: 0,
          icon: __props.icon,
          color: __props.color,
          size: "medium"
        }, null, 8, ["icon", "color"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(__props.label), 1)
  ], 10, _hoisted_1))
}
}

})